<template>
  <div>
    <table>
      <thead>
        <tr>
          <th
            v-translate
            class="text-right"
          >
            Payout
          </th>
          <th
            v-translate
            class="payout-type text-center"
          >
            Payout Type
          </th>
          <th
            v-translate
            class="text-center"
          >
            Requested On
          </th>
          <th
            v-translate
            class="payout-status text-center"
          >
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="i in 10"
          :key="`skeleton-${i}`"
          class="transaction-row"
        >
          <td class="text-right" />
          <td class="payout-type text-center" />
          <td class="text-center" />
          <td class="payout-status text-center" />
          <td />
        </tr>
      </tbody>
    </table>
  </div>
</template>
